<template>
  <CustomModal
    :visible="visible"
    @update:visible="handleVisibilityChange"
    title="SuperAGI Dialer Terms"
    width="30vw"
  >
    <div
      :id="`${source}_dialer_terms_and_conditions`"
      class="flex flex-col gap-5 proxima_nova text-[13px] font-normal text_color leading-[18px]"
    >
      <div>
        By selecting 'Agree and Continue,' you acknowledge and agree to comply
        with the
    <a
          href="https://superagi.com/terms/"
          target="_blank"
          rel="noopener noreferrer"
          class="font-semibold underline cursor-pointer hover:opacity-80"
          >SuperAGI Terms of Service</a
        >,
        <a
          href="https://www.twilio.com/en-us/legal/service-country-specific-terms/voice-sip"
          target="_blank"
          rel="noopener noreferrer"
          class="font-semibold underline cursor-pointer hover:opacity-80"
          >Twilio Voice Services Policy</a
        >, and all relevant laws and regulations, including but not limited to
        the U.S. TCPA and applicable Do Not Call guidelines in your region and
        the region of the recipient of your calls.
      </div>

      <div>
        Where applicable, you agree to obtain any necessary consent from call
        recipients before utilizing Call Recording, Transcription, and Voicemail
        Drop features of SuperAGI. You are responsible for ensuring compliance
        with legal requirements related to call recording, transcription, and
        voicemail permissions in your region and the region of the recipients of
        your call.
      </div>
    </div>

    <template #footer>
      <div class="flex flex-row items-center gap-2">
        <a-button
          class="secondary_medium"
          @click="toUpdateRecordingConsent(false)"
          >Cancel</a-button
        >
        <a-button class="primary_medium" @click="toUpdateRecordingConsent(true)"
          >Agree and Continue</a-button
        >
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import CallService from "@/src/api/CallService.js";
import CustomModal from "@/src/components/CustomModal.vue";
import store from "@/src/store/index.js";
import eventBus from "@/src/utils/eventBus.js";

const props = defineProps({
  source: { type: String, required: true },
  visible: { type: Boolean, required: true },
});

const emit = defineEmits(["update:visible"]);

const closeModal = () => {
  emit("update:visible", false);
};

const handleVisibilityChange = (newValue) => {
  if (!newValue) {
    eventBus.emit("consent-cancel");
    closeModal();
  }
};

const toUpdateRecordingConsent = async (status) => {
  try {
    const payload = {
      consent: status,
    };

    if (status) {
      const response = await CallService.updateRecordingConsent(payload);
      if (response?.success) {
        await store.dispatch("calls/setRecordingConsentStatus", true);
      }
    } else await eventBus.emit("consent-cancel");
  } catch (error) {
    console.error(
      "An error occurred while updating recording consent: ",
      error,
    );
  } finally {
    closeModal();
  }
};
</script>
